// =============================================================================
//  Copyright : 2025 semantics GmbH
//  Date      : $Date: 2025-12-09 18:28:26 +0100 (Tue, 09 Dec 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 159078 $
//  Purpose   : menuItems for tree nodes
// =============================================================================
// ---Third-party imports
import React, {createElement} from 'react'
import {isValidElementType, isElement, isFragment} from 'react-is'
import clsx from 'clsx'

// ---Framework imports
import {Actions, Sel} from 'uix/registries'
import log from 'uix/logging'
import {useSelector, usePartContext} from 'uix/hooks'
import {dict, items, isString} from 'ldash'
import {checkAcl} from 'uix/auth/acl'
import {NodeMenuItems} from 'uix/registry'

export const NodeMenu = ({node}) => {
  let {i18n, dname, dconfig, user, request} = usePartContext()

  // XXX: we need to configure visibility via item config
  if (!(request.classname == 'tree' && request.tabname == 'id')) {
    return null
  }

  let createItem = (name, c, props) => {
    // create react element
    props = {...props, key: name, i18n, dconfig, node}
    if (isElement(c) || isFragment(c)) {
      return <React.Fragment key={props.key}>{c}</React.Fragment>
    } else if (!isString(c) && isValidElementType(c)) {
      return createElement(c, props)
    } else {
      return createElement(() => c, props)
    }
  }
  let isAllowed = cfg => !cfg.acl || checkAcl(cfg.acl, user, dname)
  let enabledCheck = cfg => cfg.enabled?.({node, dconfig}) ?? true
  let datatypeCheck = cfg => !cfg.datatypes || cfg.datatypes.includes(node.datatypeName)
  let is_on = ([name, cfg]) => isAllowed(cfg) && enabledCheck(cfg) && datatypeCheck(cfg)

  let res = items(NodeMenuItems)
    .filter(is_on)
    .map(([name, cfg]) => {
      let {nodeMenuItem: c, ...props} = cfg
      if (!c) {
        c = `No nodeMenuItem implemented for ${name}`
      }
      return createItem(name, c, props)
    })
  return res
}
